import AppLayout from "./app";
import AuthLayout from "./auth";
import { FC } from "react";
import _ from "lodash";
import _404Layout from "./_404";
import { useMatches } from "react-location";

const LayoutProvider: FC = () => {
  const matches = useMatches();
  const meta = _.last(matches)?.route?.meta;


  switch (meta?.layout) {
    case "App": {
      return <AppLayout />;
    }
    case "Auth": {
      return <AuthLayout />;
    }
    default: {
      return <_404Layout />;
    }
  }

  // return <AppLayout />
};

export default LayoutProvider;
